import moment from 'moment';

// Function to format date to 'DD-MMM-YYYY'
export const formatDate = (date) => {
  return moment.utc(date).format("DD-MMM-YYYY HH:mm:ss") + " UTC";
};

export const formatDateOnly = (date) => {
  const parsedDate = moment(date, [
    moment.ISO_8601,      // e.g., "2025-04-26T21:00:00"
    "YYYY-MM-DDTHH:mm A", // e.g., "2025-04-26T02:30 PM"
  ]);

  return parsedDate.isValid() ? parsedDate.format("DD-MMM-YYYY") : date;
};

export const formatDayMonth = (date) => {
  if (!date || !moment(date, moment.ISO_8601, true).isValid()) {
    return date;
  }
  return moment.utc(date).local().format("DD MMM");
};


// Function to get the current date in 'DD-MMM-YYYY' format
export const getCurrentDate = () => {
  return moment().format('DD-MMM-YYYY');
};

// Function to get the start of the current month
export const startOfMonth = () => {
  return moment().startOf('month').format('DD-MMM-YYYY');
};

// Function to get the end of the current month
export const endOfMonth = () => {
  return moment().endOf('month').format('DD-MMM-YYYY');
};

// Function to format date to 'YYYY-MM-DD'
export const formatToISO = (date) => {
  return moment(date).format('YYYY-MM-DD');
};

// Function to check if the date is a valid date
export const isValidDate = (date) => {
  return moment(date, 'DD-MMM-YYYY', true).isValid();
};

// Function to add days to a given date
export const addDays = (date, days) => {
  return moment(date).add(days, 'days').format('DD-MMM-YYYY');
};

// Function to subtract days from a given date
export const subtractDays = (date, days) => {
  return moment(date).subtract(days, 'days').format('DD-MMM-YYYY');
};

// Function to get the difference between two dates in days
export const dateDifference = (startDate, endDate) => {
  return moment(endDate).diff(moment(startDate), 'days');
};
